/**
 * Filenames of browser-extension scripts. Deliberately unanchored: the Capacitor SDK rewrites stack frames to
 * `app:///<filename>`, so an extension frame arrives as `app:///chrome-extension://<id>/main.bundle.js`.
 */
export const EXTENSION_URLS: RegExp[] = [/extensions\//i, /chrome-extension:\/\//i, /moz-extension:\/\//i]

/**
 * Filenames of third-party scripts injected into the page by a tag manager rather than shipped by us. Cookiebot serves
 * its consent dialog bundle from a per-site GUID directory, e.g. `/b9b9c00c-7571-4ef2-aec7-da61c9cda61e/cc.js`.
 */
export const THIRD_PARTY_SCRIPT_URLS: RegExp[] = [/\/[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}\/cc\.js/i]

/**
 * Filenames of code that is never ours, whichever frame of the stacktrace it appears in.
 */
export const DISOWNED_URLS: RegExp[] = [...EXTENSION_URLS, ...THIRD_PARTY_SCRIPT_URLS]

/**
 * Filenames of scripts we never want to hear about: browser extensions and third-party tags.
 */
export const DENY_URLS: RegExp[] = [...DISOWNED_URLS, /\/gtm\.js/i, /\/gtag\/js/i, /fbevents\.js/i]

export const TO_IGNORE_ERRORS: (string | RegExp)[] = [
  /ResizeObserver loop/,
  'Non-Error promise rejection',
  /ct.pinterest.com/,
  /runtime.sendMessage/,
  /\bbrowser\.storage\./, // WebExtension storage API: unreachable from a page script
  /\(evaluating 'window\./,
  /__firefox__/,
  'Object Not Found Matching Id:1, MethodName:update, ParamCount:4', // This error is thrown by Outlook crawlers and is not relevant
  "undefined is not an object (evaluating 'a.L')" // An error thrown by Google Translate primarily on Chrome Mobile iOS. Not relevant, blocking or fixable by us.
]

/**
 * Keys that are replaced by [REDACTED] in the Sentry logs
 */
export const PERSONAL_DATA_KEYS: ReadonlySet<string> = new Set(
  [
    'email',
    'emailConfirmation',
    'firstName',
    'lastName',
    'phone',
    'phoneMobile',
    'phoneNumber',
    'mobilePhone',
    'iban',
    'ibanNumber',
    'streetName',
    'streetNumber',
    'streetBox',
    'coordinates',
    'customerNumber',
    'enterpriseNumber',
    'companyName'
  ].map((key) => key.toLowerCase())
)
